// The finish video's on-screen dressing: a "Photo finish · replay" label and thin letterbox bars,
// so nobody mistakes the slow-motion replay for the live race. Drawn over the canvas, under the HUD.

const STYLE_ID = 'finish-replay-style';
const CSS = `
.finish-replay { position: absolute; inset: 0; pointer-events: none; opacity: 0; transition: opacity .3s ease; }
.finish-replay.show { opacity: 1; }
.finish-replay::before, .finish-replay::after { content: ''; position: absolute; left: 0; right: 0; height: 6vh;
  background: #0b070dd9; transition: transform .4s ease; }
.finish-replay::before { top: 0; transform: translateY(-100%); }
.finish-replay::after { bottom: 0; transform: translateY(100%); }
.finish-replay.show::before, .finish-replay.show::after { transform: none; }
.finish-replay > span { position: absolute; left: 50%; top: calc(6vh + 64px); transform: translateX(-50%);
  padding: 4px 12px; border-radius: 6px; background: #211923e6; border: 2px solid #f2c35b; color: #fff3dc;
  font: 800 13px/1.4 system-ui, sans-serif; letter-spacing: .1em; text-transform: uppercase; white-space: nowrap; }
.finish-replay > span::before { content: ''; display: inline-block; margin-right: 8px; vertical-align: 0;
  border-style: solid; border-width: 5px 0 5px 8px; border-color: transparent transparent transparent #f2c35b; }
/* phones: keep the label clear of the HUD's standings and results panels */
@media (max-width: 760px) and (min-height: 501px) { .finish-replay > span { top: max(30%, 220px); } }
@media (max-height: 500px) { .finish-replay > span { left: auto; right: max(12px, env(safe-area-inset-right)); top: 48px; transform: none; } }
@media (prefers-reduced-motion: reduce) { .finish-replay::before, .finish-replay::after { transition: none; } }
`;

export class ReplayBadge {
  private el: HTMLDivElement;
  private shown = false;

  constructor(container: HTMLElement) {
    if (!document.getElementById(STYLE_ID)) {
      const s = document.createElement('style');
      s.id = STYLE_ID;
      s.textContent = CSS;
      document.head.appendChild(s);
    }
    this.el = document.createElement('div');
    this.el.className = 'finish-replay';
    this.el.setAttribute('aria-hidden', 'true');
    const label = document.createElement('span');
    label.textContent = 'Photo finish · replay';
    this.el.appendChild(label);
    container.appendChild(this.el);
  }

  update(show: boolean): void {
    if (show === this.shown) return;
    this.shown = show;
    this.el.classList.toggle('show', show);
    this.el.setAttribute('aria-hidden', String(!show));
  }
}
